import { HStack, Text } from '@chakra-ui/react'

import { Icon } from '../Icon'

export interface IPaneHeaderProps {
  /** Classe do Lineicons, como no `<Icon>`. */
  icon: string
  label: string
  /** Variante escura, para o painel da prévia que imita o visual do site. */
  dark?: boolean
}

/**
 * Cabeçalho fixo de um painel rolável dos modais de duas colunas (editor + prévia).
 *
 * Nasceu no editor de campos de obra (ABRA-84) e foi copiado para o editor da pesquisa NPS de
 * evento (ABRA-370); com duas cópias iguais, virou componente.
 */
export default function PaneHeader({ icon, label, dark = false }: IPaneHeaderProps) {
  return (
    <HStack
      position="sticky"
      top={0}
      zIndex={1}
      px={5}
      py={3}
      spacing={2}
      bg={dark ? '#0a0a0a' : 'white'}
      borderBottom="1px solid"
      borderColor={dark ? 'whiteAlpha.200' : 'gray.200'}
    >
      <Icon name={icon} color="magenta.500" />
      <Text fontWeight="semibold" fontSize="sm" color={dark ? 'whiteAlpha.800' : 'gray.700'}>
        {label}
      </Text>
    </HStack>
  )
}
